<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-icon left color="accent">mdi-clipboard-text</v-icon>Customers
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn outlined @click="formCustomer = true">
              <v-icon left>mdi-plus</v-icon>Add Customer
            </v-btn>
            <template v-slot:extension>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </template>
          </v-toolbar>
          <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :options.sync="options"
            :server-items-length="totalCount"
          >
            <template v-slot:item.actions="{item}">
              <v-btn small outlined @click="open(item.id)">
                View
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
        <customer-form
          :item="customerToEdit"
          :open="formCustomer"
          v-on:add="addCustomer"
          v-on:cancel="cancelCustomer()"
          v-on:update="updateCustomer()"
        ></customer-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CustomerForm from "@components/client/CustomerForm";
import _ from "lodash";

export default {
  components: {
    CustomerForm,
  },
  data() {
    return {
      search: "",
      headers: [
        { text: "Company", value: "company", align: "left" },
        { text: "Last Name", value: "lastname", align: "left" },
        { text: "First Name", value: "firstname" },
        { text: "email", value: "email" },
        { text: "mobile", value: "mobile" },
        { text: "Actions", value: "actions", sortable: false }
      ],
      options: { itemsPerPage: 20 },
      formCustomer: false,
      customerToEdit: null
    };
  },
  watch: {
    options: {
      handler: _.debounce(function() {
        this.getClients();
      }, 100)
    },
    search: {
      handler: _.debounce(function() {
        this.getClients();
      }, 100)
    }
  },
  computed: {
    tableData: function() {
      return this.$store.getters["clients/clients"];
    },
    loading: function() {
      return this.$store.getters["clients/loading"];
    },
    totalCount: function() {
      return this.$store.getters["clients/totalCount"];
    }
  },
  mounted: function() {
    this.getClients(); //method1 will execute at pageload
  },
  methods: {
    getClients() {
      this.$store.dispatch("clients/index", {
        pagination: this.options,
        filter: {
          search: this.search
        }
      });
    },
    addCustomer(client) {
      console.log("addCustomer", client);
      this.open(client.id)
    },
    cancelCustomer(){
      this.formCustomer=false;
      this.customerToEdit = null;
    },
    open(id) {
      this.$router.push("/clients/view/" + id);
    }
  }
};
</script>
